<template>
    <div class="card-image-overlay fill-height d-flex align-center justify-center">
        <div v-if="!availableInCountry" class="text-center">
            {{ $vuetify.lang.t('$vuetify.shop.unavailable_in_your_country') }}
        </div>
        <div v-else-if="unavailable" class="text-center">
            {{ $vuetify.lang.t('$vuetify.shop.unavailable') }}
        </div>
        <div v-else-if="inactive" class="text-center">
            {{ $vuetify.lang.t('$vuetify.shop.inactive') }}
            <div v-if="detailView" class="text-center">
                {{ $vuetify.lang.t('$vuetify.shop.inactive_addition') }}
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'card-image-overlay',
        props: {
            inactive: {
                type: Boolean,
                default: false,
            },
            unavailable: {
                type: Boolean,
                default: false,
            },
            availableInCountry: {
                type: Boolean,
                default: true,
            },
            detailView: {
                type: Boolean,
                default: false,
            }
        }
    }
</script>
